import React, { useRef, useState, useEffect } from 'react';
import { DivContainer, DivDiffResult } from './diffSearch.styled';
import Search from '../search/search';
import { getUserInfoDiff } from '../../api/internal/usersInternalApi';
import { RenderNestedObject } from '../../utils/renderNestedObject';

export default function DiffSearch({user, setUser, differences}) {
    const inputRef = useRef();
    const [isActiveDiffSearch, setIsActiveDiffSearch] = useState();
    const [isActiveDiffSearchError, setIsActiveDiffSearchError] = useState();

    useEffect(() => {
        if (isActiveDiffSearch && inputRef.current?.value) {
            const fetchData = async () => {
                try {
                    const filterRow = [{
                        id: 1,
                        operator: 'AND',
                        comparator: 'equals',
                        information: 'Users',
                        propertie: 'userPrincipalName',
                        input: inputRef.current.value
                    }];

                    const advancedFilters = encodeURIComponent(JSON.stringify(filterRow));
                    
                    const request = `filtersInformation=Users&advancedFilters=${advancedFilters}&page=1&limit=1`;

                    const data = await getUserInfoDiff(request, setIsActiveDiffSearchError);
                    setUser(data);

                } catch (error) {
                    console.error("Erreur lors de la récupération des infos utilisateur", error);
                    setIsActiveDiffSearchError("Erreur technique lors de la recherche");
                }
            };
            fetchData();
        }
    }, [isActiveDiffSearch, setUser]);

    return (
        <>
            <DivContainer>
                <div className='search-diff-container'>
                    <Search 
                        inputRef={inputRef} 
                        inputPlaceHolder={"Rentrez l'adresse mail d'un utilisateur"} 
                        page="Diff" 
                        needFilters={false} 
                        filterRow={null} 
                        setFilterRow={null} 
                        isActiveDiffSearch={isActiveDiffSearch} 
                        setIsActiveDiffSearch={setIsActiveDiffSearch} 
                        isActiveDiffSearchError={isActiveDiffSearchError}
                    />
                </div>
                {
                    isActiveDiffSearch && user?.data ? (
                        <DivDiffResult>
                            <RenderNestedObject 
                                data={user.data} 
                                exclude={['_id', '__v', 'profilePicture']} 
                                models={undefined} 
                                onClickDetail={null} 
                                primaryKey={undefined} 
                                diffPageRender={true} 
                                differences={differences} 
                            />
                        </DivDiffResult>
                    ) : null
                }
            </DivContainer>
        </>
    )
}